import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Table,
    Overlay,
    Popover,
    Col,
    Form,
    Row,
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import property from "../../../../Assets/Images/Configuration/property.svg";
import { Doughnut, Line } from "react-chartjs-2";
import DayRangeChart from "./DayRangeChart";
import ChartIcon from "../../../../Assets/Images/Revenue-management/strategy.svg";

import highPriority from "../../../../Assets/Images/Revenue-management/highPriority.svg";
import lowPriority from "../../../../Assets/Images/Revenue-management/lowPriority.svg";
import { MultiSelect } from "primereact/multiselect";
import Skeleton from "../../../Skeletons/Skeleton";

export const PerformanceADRMonitor = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const [selectedMarketSegment, setSelectedMarketSegment] = useState([]);
    const [selectedTempMarketSegment, setSelectedTempMarketSegment] = useState([]);
    const [marketSegmentData, setMarketSegmentData] = useState([]);
    const multiselectRef = useRef(null);
    const handleApply = () => {
        setSelectedMarketSegment(selectedTempMarketSegment);
        multiselectRef.current.hide();
    };

    const [show, setShow] = useState(false);
    const targetRef = useRef(null);
    const handleMouseEnter = () => setShow(true);
    const handleMouseLeave = () => setShow(false);

    const PropertyScore_chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
        },
    };

    const [PropertyScore_chartData, setPropertyScore_chartData] = useState({
        datasets: [
            {
                data: [0, 100 - 0],
                backgroundColor: (context) => {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;

                    if (!chartArea) {
                        return null; // Return null before chart is rendered
                    }

                    if (context.dataIndex === 1) return "#e6e6e6";

                    const gradient = ctx.createLinearGradient(0, 0, chart.width, 0);
                    gradient.addColorStop(1, "#FFC145");
                    gradient.addColorStop(0.5, "#ECE852");
                    gradient.addColorStop(0, "#5CB338");

                    return gradient;
                },
                borderWidth: 0,
                cutout: "75%",
            },
        ],
    });

    const [PropertyScore, setPropertyScor] = useState({
        Dates: "1900-01-01",
        ADR: "0",
        "ADR Difference": "0",
        "ADR Difference Perc": "0",
        "Forecasted Room Sold": 0,
        OutOfOrder: 0,
        Inventory: 0,
        RoomSold: 0,
        "Left To Sell": 0,
        Highest_ADR_Past_8_Weeks: "0",
        Lowest_ADR_Past_8_Weeks: "0",
        max_rate: "0",
        max_booking_date: "1900-01-01",
        max_booking_time: "00:00:00",
        min_rate: "0",
        min_booking_date: "1900-01-01",
        min_booking_time: "00:00:00",
        BAR_Rate: "0",
        Average_MPI: "0",
        Average_ARI: "0",
        Average_RGI: "0",
        Property_Score: "0",
    });

    const [performance_dashboard_loader, setperformance_dashboard_loader] =
        useState(false);

    const performance_dashboard = async () => {
        setperformance_dashboard_loader(true);

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);

        let customday = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.MONEY_CONTROL.DAILY_PERFORMANCE_DASHBOARD,
                body: {
                    propertyCode: para?.propertyCode,
                    channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    ForcastType : propertyDetailFromRTK?.revenuconfig?.[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig?.[0]?.forcasttype_term : ""
                },
            },
            false
        );

        let customdayresponse = apiResponse(false, customday);

        if (customdayresponse?.isValidate) {
            let _PropertyScor = customdayresponse?.data?.data[0];
            _PropertyScor["ADR"] = _PropertyScor["ADR"]
                ? parseFloat(_PropertyScor["ADR"])
                : 0;
            _PropertyScor["ADR Difference"] = _PropertyScor["ADR Difference"]
                ? parseFloat(_PropertyScor["ADR Difference"])
                : 0;
            _PropertyScor["ADR Difference Perc"] = _PropertyScor[
                "ADR Difference Perc"
            ]
                ? parseFloat(_PropertyScor["ADR Difference Perc"])
                : 0;
            _PropertyScor["Forecasted Room Sold"] = _PropertyScor[
                "Forecasted Room Sold"
            ]
                ? parseInt(_PropertyScor["Forecasted Room Sold"])
                : 0;
            _PropertyScor["OutOfOrder"] = _PropertyScor["OutOfOrder"]
                ? parseInt(_PropertyScor["OutOfOrder"])
                : 0;
            _PropertyScor["Inventory"] = _PropertyScor["Inventory"]
                ? parseInt(_PropertyScor["Inventory"])
                : 0;
            _PropertyScor["RoomSold"] = _PropertyScor["RoomSold"]
                ? parseInt(_PropertyScor["RoomSold"])
                : 0;
            _PropertyScor["Left To Sell"] = _PropertyScor["Left To Sell"]
                ? parseInt(_PropertyScor["Left To Sell"])
                : 0;
            _PropertyScor["Highest_ADR_Past_8_Weeks"] = _PropertyScor[
                "Highest_ADR_Past_8_Weeks"
            ]
                ? parseFloat(_PropertyScor["Highest_ADR_Past_8_Weeks"])
                : 0;
            _PropertyScor["Lowest_ADR_Past_8_Weeks"] = _PropertyScor[
                "Lowest_ADR_Past_8_Weeks"
            ]
                ? parseFloat(_PropertyScor["Lowest_ADR_Past_8_Weeks"])
                : 0;
            _PropertyScor["max_rate"] = _PropertyScor["max_rate"]
                ? parseFloat(_PropertyScor["max_rate"])
                : 0;
            _PropertyScor["min_rate"] = _PropertyScor["min_rate"]
                ? parseFloat(_PropertyScor["min_rate"])
                : 0;
            _PropertyScor["BAR_Rate"] = _PropertyScor["BAR_Rate"]
                ? parseFloat(_PropertyScor["BAR_Rate"])
                : 0;
            _PropertyScor["Average_MPI"] = _PropertyScor["Average_MPI"]
                ? parseFloat(_PropertyScor["Average_MPI"])
                : 0;
            _PropertyScor["Average_ARI"] = _PropertyScor["Average_ARI"]
                ? parseFloat(_PropertyScor["Average_ARI"])
                : 0;
            _PropertyScor["Average_RGI"] = _PropertyScor["Average_RGI"]
                ? parseFloat(_PropertyScor["Average_RGI"])
                : 0;
            _PropertyScor["Property_Score"] = _PropertyScor["Property_Score"]
                ? parseFloat(_PropertyScor["Property_Score"])
                : 0;

            setPropertyScor(_PropertyScor);
            setperformance_dashboard_loader(false);

            let score = _PropertyScor["Property_Score"]
                ? parseInt(_PropertyScor["Property_Score"])
                : 0;
            setPropertyScore_chartData((prev) => {
                if (!prev || !prev.datasets || !prev.datasets.length) return prev;
                let newData = { ...prev };
                newData.datasets = [...prev.datasets];
                newData.datasets[0] = { ...prev.datasets[0] };
                newData.datasets[0].data = [score, 100 - score];
                return newData;
            });
        }

        setperformance_dashboard_loader(false);
    };

    const ADRByDate_options = {
        responsive: true,
        plugins: {
            legend: { display: true },
            tooltip: {
                mode: "index",
                intersect: false,
                callbacks: {
                    label: function (context) {
                        const dataset = context.dataset;
                        return `${dataset.label}: ${dataset.label !== "ADR"
                            ? context.formattedValue
                            : commonService.formateAmount(context.formattedValue)
                            }`;
                    },
                },
            },
        },
        scales: {
            x: {
                title: { display: false, text: "Booking Date" },
            },
            yADR: {
                position: "left",
                title: {
                    display: true,
                    text: "ADR",
                },
            },
            yOCC: {
                position: "right",
                title: {
                    display: true,
                    text: "RoomSold",
                },
                max: propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms ? parseInt(propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms) : undefined,
            },
            //y: {
            //    display: true,
            //    title: { display: true, text: 'ADR' },
            //    beginAtZero: true,
            //},

            //y1: {
            //    display: true,
            //    title: { display: true, text: 'OCC' },
            //    beginAtZero: true,
            //},
        },
    };

    const [ADRByDate_data, setADRByDate_data] = useState({
        labels: [
            "Nov 1900",
            "Dec 1900",
            "Jan 1900",
            "Feb 1900",
            "Mar 1900",
            "Apr 1900",
        ],
        datasets: [
            {
                label: "ADR",
                data: [0, 0, 0, 0, 0, 0],
                borderColor: "rgba(54, 162, 235, 1)",
                backgroundColor: "rgba(54, 162, 235, 0.1)",
                pointBackgroundColor: "rgba(54, 162, 235, 1)",
                pointBorderColor: "#fff",
                pointRadius: 4,
                pointHoverRadius: 6,
                borderWidth: 2,
                fill: true,
                tension: 0.3,
                borderDash: [5, 5], // for dotted line
                yAxisID: "yADR",
            },
            {
                label: "RoomSold",
                data: [0, 0, 0, 0, 0, 0],
                borderColor: "rgba(235, 173, 54, 1)",
                backgroundColor: "rgba(235, 173, 54, 0.1)",
                pointBackgroundColor: "rgba(235, 173, 54, 1)",
                pointBorderColor: "#fff",
                pointRadius: 4,
                pointHoverRadius: 6,
                borderWidth: 2,
                fill: true,
                tension: 0.3,
                borderDash: [5, 5], // for dotted line
                yAxisID: "yOCC",
            },
        ],
    });

    const [adr_by_bookingdate_loader, setadr_by_bookingdate_loader] =
        useState(false);
    const adr_by_bookingdate = async () => {
        setadr_by_bookingdate_loader(true);
        let customday = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.MONEY_CONTROL.ADR_BY_BOOKINGDATE,
                body: {
                    propertyCode: para?.propertyCode,
                    staydate: para?.asOfDate,
                    marketsegment: selectedMarketSegment && selectedMarketSegment.length > 0 ? selectedMarketSegment.join(",") : null
                },
            },
            false
        );

        let customdayresponse = apiResponse(false, customday);

        if (customdayresponse?.isValidate) {
            const sortedData = customdayresponse?.data?.data.sort(
                (a, b) => new Date(a.Booking_Date) - new Date(b.Booking_Date)
            );
            let labels = [];
            let data = [];
            let dataOCCPer = [];
            for (let i = 0; i < sortedData.length; i++) {
                labels.push(commonService.getDateInFormat(sortedData[i].Booking_Date));
                //data.push(parseInt(sortedData[i].Average_ADR))
                //dataOCCPer.push(parseInt(sortedData[i].Occperc))

                data.push(parseInt(sortedData[i].ADR));
                dataOCCPer.push(parseInt(sortedData[i].RoomSold));
            }
            let _ADRByDate_data = structuredClone(ADRByDate_data);
            _ADRByDate_data.labels = labels;
            _ADRByDate_data.datasets[0].data = data;
            _ADRByDate_data.datasets[1].data = dataOCCPer;

            setADRByDate_data(_ADRByDate_data);
        }

        setadr_by_bookingdate_loader(false);
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.propertyCode) {
                performance_dashboard();
                adr_by_bookingdate();
            }
        }
    }, [para?.propertyCode]);








    const footerTemplate = () => (
        <div style={{ padding: "0.5rem", textAlign: "right" }}>
            <Button id={commonService.generateGlobalClickTrackerID("PerformanceADRMonitor", "apply", propertyCode)}
                onClick={handleApply}
            >Apply</Button>
        </div>
    );

    const getTermListByProperty = async () => {
        setMarketSegmentData([])
        if (propertyDetailFromRTK) {
            let termListResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.Configuration +
                        API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY,
                    body: { categorynamebycomma: "Market Segment", propertyid: propertyDetailFromRTK.propertyid },
                },
                false
            );

            let response = apiResponse(false, termListResponse);

            if (response?.isValidate) {

                let data = response?.data?.data?.filter((f) => f.termcategoryname === "Market Segment");
                if (data) {
                    let lst = [];
                    data.map((item, index) => lst.push({ label: item.term, value: item.term }));
                    setMarketSegmentData(lst);
                }
            }
        }

    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.propertyCode) {
                adr_by_bookingdate();
            }
        }
    }, [para?.propertyCode, selectedMarketSegment]);

    useEffect(() => {
        getTermListByProperty();
    }, [propertyDetailFromRTK]);

    return (
        <div className="widget-container" style={{ position: "relative", padding: "0 5px" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PerformanceADRMonitor", "infoIcon", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.PerformanceADRMonitor,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                </div>
            )}
            {performance_dashboard_loader ? (
                <Skeleton skeletonType="PerformanceADRMonitor" />
            ) : (
                <table>
                    <tbody>
                        <tr>
                            <td style={{ width: "16.66666666666667%" }}>
                                <div className="flex-child align-middle allSettingsBox ">
                                    <div>Forecast</div>
                                    <div>
                                        <b>
                                            {PropertyScore["Forecasted Room Sold"]
                                                ? parseFloat(PropertyScore["Forecasted Room Sold"])
                                                : 0}
                                        </b>
                                    </div>
                                </div>
                            </td>
                            <td style={{ width: "16.66666666666667%" }}>
                                <div className="flex-child align-middle allSettingsBox ">
                                    <div>Inventory</div>
                                    <div>
                                        <b>
                                            {PropertyScore["Inventory"]
                                                ? parseFloat(PropertyScore["Inventory"])
                                                : 0}
                                        </b>
                                    </div>
                                </div>
                            </td>
                            <td style={{ width: "16.66666666666667%" }}>
                                <div className="flex-child  align-middle allSettingsBox ">
                                    <div>OOO</div>
                                    <div>
                                        <b>
                                            {PropertyScore["OutOfOrder"]
                                                ? parseFloat(PropertyScore["OutOfOrder"])
                                                : 0}
                                        </b>
                                    </div>
                                </div>
                            </td>
                            <td style={{ width: "16.66666666666667%" }}>
                                <div className="flex-child align-middle allSettingsBox ">
                                    <div>Rooms Sold</div>
                                    <div>
                                        <b>
                                            {PropertyScore["RoomSold"]
                                                ? parseFloat(PropertyScore["RoomSold"])
                                                : 0}
                                        </b>
                                    </div>
                                </div>
                            </td>
                            <td style={{ width: "16.66666666666667%" }}>
                                <div className="flex-child align-middle allSettingsBox ">
                                    <div>Left to Sell</div>
                                    <div>
                                        <b>
                                            {PropertyScore["Left To Sell"]
                                                ? parseFloat(PropertyScore["Left To Sell"])
                                                : 0}
                                        </b>
                                    </div>
                                </div>
                            </td>
                            <td style={{ width: "16.66666666666667%" }}>
                                <div className="flex-child align-middle allSettingsBox ">
                                    <div>Date</div>
                                    <div>
                                        <b>
                                            {PropertyScore["Dates"]
                                                ? commonService.getDateInFormat(PropertyScore["Dates"])
                                                : ""}
                                        </b>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
            <table>
                <tr>
                    <td
                        style={performance_dashboard_loader ? { width: "58.33333333%" } : {
                            width: "41.66666667%",
                            verticalAlign: "top",
                            paddingTop: "10px",
                        }} className={performance_dashboard_loader ? "ADRByBookingDate" : ""}
                    >
                        <div>
                          {performance_dashboard_loader ? (
                            <tr className="d-flex justify-content-center" style={{ height: "80px", position: "relative" }}>
                                <Loader />
                            </tr>
                        ) : (
                            <table>
                                <tr>
                                    <td>
                                        <table>
                                            <tr>
                                                <td
                                                    style={{
                                                        width: "70%",
                                                        verticalAlign: "top",
                                                        paddingRight: "10px",
                                                    }}
                                                >
                                                    <table>
                                                        <tr>
                                                            <td colSpan={2} style={{ paddingBottom: "8px" }}>
                                                                <div className="flex-child text-center align-middle allSettingsBox m-0">
                                                                    <div>ADR</div>
                                                                    <div>
                                                                        <h3>
                                                                            {commonService.formateAmount(
                                                                                PropertyScore.ADR
                                                                            )}
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div class="flex-child text-center align-middle allSettingsBox ms-0">
                                                                    <div>ADR Diff.</div>
                                                                    <div>
                                                                        <b
                                                                            className={`p-0 m-0 ${PropertyScore["ADR Difference"]
                                                                                ? parseFloat(
                                                                                    PropertyScore["ADR Difference"]
                                                                                ) > 0
                                                                                    ? "text-success"
                                                                                    : "text-danger"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {PropertyScore["ADR Difference"] ? (
                                                                                parseFloat(
                                                                                    PropertyScore["ADR Difference"]
                                                                                ) > 0 ? (
                                                                                    <img src={highPriority} alt="" />
                                                                                ) : (
                                                                                    <img src={lowPriority} alt="" />
                                                                                )
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                            {commonService.formateAmount(
                                                                                PropertyScore["ADR Difference"]
                                                                            )}
                                                                        </b>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="flex-child text-center align-middle allSettingsBox me-0">
                                                                    <div>ADR Diff. %</div>
                                                                    <div>
                                                                        <b
                                                                            className={`p-0 m-0 ${PropertyScore["ADR Difference Perc"]
                                                                                ? parseFloat(
                                                                                    PropertyScore[
                                                                                    "ADR Difference Perc"
                                                                                    ]
                                                                                ) > 0
                                                                                    ? "text-success"
                                                                                    : "text-danger"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {PropertyScore["ADR Difference Perc"] ? (
                                                                                parseFloat(
                                                                                    PropertyScore["ADR Difference Perc"]
                                                                                ) > 0 ? (
                                                                                    <img src={highPriority} alt="" />
                                                                                ) : (
                                                                                    <img src={lowPriority} alt="" />
                                                                                )
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                            {PropertyScore["ADR Difference Perc"]}%
                                                                        </b>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td
                                                    style={{ Width: "30%", verticalAlign: "top" }}
                                                >
                                                    <div
                                                        class="property-score-card"
                                                        style={{ height: "100%" }}
                                                        ref={targetRef}
                                                        onMouseEnter={handleMouseEnter}
                                                        onMouseLeave={handleMouseLeave}
                                                    >
                                                        <div class="icon-and-title">
                                                            <img src={property} alt="" />{" "}
                                                            <b>Property Score</b>
                                                        </div>
                                                        <div class="chartWrapper">
                                                            <Doughnut
                                                                style={{ height: "100%", width: "100%" }}
                                                                data={PropertyScore_chartData}
                                                                options={PropertyScore_chartOptions}
                                                            />
                                                            <div className="scoreText">
                                                                {PropertyScore["Property_Score"]
                                                                    ? parseInt(PropertyScore["Property_Score"])
                                                                    : 0}
                                                            </div>
                                                            <div className="subText">/100</div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="flex-container  mb-3">
                                            <DayRangeChart
                                                low={
                                                    PropertyScore["min_rate"]
                                                        ? parseFloat(PropertyScore["min_rate"])
                                                        : 0
                                                }
                                                high={
                                                    PropertyScore["max_rate"]
                                                        ? parseFloat(PropertyScore["max_rate"])
                                                        : 0
                                                }
                                                current={
                                                    PropertyScore["BAR_Rate"]
                                                        ? parseFloat(PropertyScore["BAR_Rate"])
                                                        : 0
                                                }
                                                low_in_formet={commonService.formateAmount(
                                                    PropertyScore["min_rate"]
                                                        ? parseFloat(PropertyScore["min_rate"])
                                                        : 0
                                                )}
                                                high_in_formet={commonService.formateAmount(
                                                    PropertyScore["max_rate"]
                                                        ? parseFloat(PropertyScore["max_rate"])
                                                        : 0
                                                )}
                                                current_in_formet={
                                                    "BAR " +
                                                    commonService.formateAmount(
                                                        PropertyScore["BAR_Rate"]
                                                            ? parseFloat(PropertyScore["BAR_Rate"])
                                                            : 0
                                                    )
                                                }
                                                chart_Title={"Day Range"}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="flex-container  mb-3">
                                            <DayRangeChart
                                                low={
                                                    PropertyScore["Lowest_ADR_Past_8_Weeks"]
                                                        ? parseFloat(
                                                            PropertyScore["Lowest_ADR_Past_8_Weeks"]
                                                        )
                                                        : 0
                                                }
                                                high={
                                                    PropertyScore["Highest_ADR_Past_8_Weeks"]
                                                        ? parseFloat(
                                                            PropertyScore["Highest_ADR_Past_8_Weeks"]
                                                        )
                                                        : 0
                                                }
                                                current={
                                                    PropertyScore["ADR"]
                                                        ? parseFloat(PropertyScore["ADR"])
                                                        : 0
                                                }
                                                low_in_formet={commonService.formateAmount(
                                                    PropertyScore["Lowest_ADR_Past_8_Weeks"]
                                                        ? parseFloat(
                                                            PropertyScore["Lowest_ADR_Past_8_Weeks"]
                                                        )
                                                        : 0
                                                )}
                                                high_in_formet={commonService.formateAmount(
                                                    PropertyScore["Highest_ADR_Past_8_Weeks"]
                                                        ? parseFloat(
                                                            PropertyScore["Highest_ADR_Past_8_Weeks"]
                                                        )
                                                        : 0
                                                )}
                                                current_in_formet={
                                                    "ADR " +
                                                    commonService.formateAmount(
                                                        PropertyScore["ADR"]
                                                            ? parseFloat(PropertyScore["ADR"])
                                                            : 0
                                                    )
                                                }
                                                chart_Title={"8 Week Rolling"}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        )}
                        </div>
                    </td>
                    <td style={{ width: "58.33333333%" }} className="ADRByBookingDate">
                        {adr_by_bookingdate_loader ? (
                            <Loader />
                        ) : (
                            <>
                                <table>
                                    <tr>
                                        <td>
                                            <h5>ADR By Booking Date</h5>
                                        </td>
                                        <td className="width200">
                                            <MultiSelect id={commonService.generateGlobalClickTrackerID("PerformanceADRMonitor", "Market-Segment-multiselect-onchange", propertyCode)}
                                                ref={multiselectRef}
                                                filter
                                                placeholder="Select Market Segment"
                                                display="values"
                                                selectedItemsLabel="{0} market segment selected"
                                                maxSelectedLabels={0}
                                                closeOnSelect={false}
                                                value={selectedTempMarketSegment}
                                                options={marketSegmentData}
                                                onChange={(e) => {
                                                    setSelectedTempMarketSegment(e.value);
                                                }}
                                                panelFooterTemplate={footerTemplate}
                                            />
                                        </td>
                                    </tr>
                                </table>
                                <Line data={ADRByDate_data} options={ADRByDate_options} />
                            </>
                        )}
                    </td>
                </tr>
            </table>

            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"PerformanceADRMonitor"} />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            <Overlay
                show={show}
                target={targetRef.current}
                placement="bottom"
                containerPadding={10}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <div className="horizontal-menu-option active">
                        <div
                            className={`GroupNameModalMain singleDateSummaryModalMain ToolsSingleTicketPopUpMain property-score-timeline-popup`}
                        >
                            <div className="GroupNameModalHeader">
                                <h5>
                                    <b>{propertyDetailFromRTK?.propertyname}</b>
                                </h5>
                                <h5>
                                    <b>{commonService.formateAmount(PropertyScore.ADR)}</b>{" "}
                                    <span
                                        className={`p-0 m-0 ${PropertyScore["ADR Difference"]
                                            ? parseFloat(PropertyScore["ADR Difference"]) > 0
                                                ? "text-success"
                                                : "text-danger"
                                            : ""
                                            }`}
                                    >
                                        {PropertyScore["ADR Difference"] ? (
                                            parseFloat(PropertyScore["ADR Difference"]) > 0 ? (
                                                <img src={highPriority} alt="" />
                                            ) : (
                                                <img src={lowPriority} alt="" />
                                            )
                                        ) : (
                                            ""
                                        )}
                                        {commonService.formateAmount(
                                            PropertyScore["ADR Difference"]
                                        )}{" "}
                                        ({PropertyScore["ADR Difference Perc"]}%)
                                    </span>
                                </h5>
                            </div>

                            <div className="singleDateSummaryModalContent">
                                <div class="flex-container">
                                    <div class="flex-child" style={{ maxWidth: "160px" }}>
                                        <div class="property-score-card">
                                            <div class="icon-and-title">
                                                <img src={property} alt="" /> <b>Property Score</b>
                                            </div>
                                            <div class="chartWrapper">
                                                <Doughnut
                                                    data={PropertyScore_chartData}
                                                    options={PropertyScore_chartOptions}
                                                />
                                                <div className="scoreText">
                                                    {PropertyScore["Property_Score"]
                                                        ? parseInt(PropertyScore["Property_Score"])
                                                        : 0}
                                                </div>
                                                <div className="subText">/100</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-child">
                                        <div class="property-score-timeline">
                                            <div class="card">
                                                <span>
                                                    <img src={ChartIcon} alt="" className={"me-2"} />{" "}
                                                    <b className={"me-2"}>
                                                        {PropertyScore["Average_MPI"]}
                                                    </b>{" "}
                                                    MPI (Market Penetration Index)
                                                </span>
                                            </div>

                                            <div class="card">
                                                <span>
                                                    <img src={ChartIcon} alt="" className={"me-2"} />{" "}
                                                    <b className={"me-2"}>
                                                        {PropertyScore["Average_ARI"]}
                                                    </b>{" "}
                                                    ARI (Average Rate Index)
                                                </span>
                                            </div>

                                            <div class="card">
                                                <span>
                                                    <img src={ChartIcon} alt="" className={"me-2"} />{" "}
                                                    <b className={"me-2"}>
                                                        {PropertyScore["Average_RGI"]}
                                                    </b>{" "}
                                                    RGI (Revenue Generation Index)
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popover>
            </Overlay>
        </div>
    );
};

export default PerformanceADRMonitor;
